module.exports = __webpack_public_path__ + "img/Inflammation-PDAC_GSE205354.ec80bb6f.png";